// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1i74_","alertIcon":"ConfirmModal_alertIcon__3O1Xa"};